import axios from 'axios';
import { getItem, removeItem } from '../../utility/localStorageControl';
import { API } from '../api';
import store from '../../redux/store';
import actions from '../../redux/authentication/actions';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
  },
});

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use(config => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = { Authorization: `Bearer ${getItem('access_token')}`, ...headers };
  return requestConfig;
});

client.interceptors.response.use(
  response => response,
  async error => {
    const { response, config } = error;

    if (response?.status === 404) response.notFound = true;

    if (response?.status === 401 && config.url !== API.auth.currentUser && !config._retried) {
      config._retried = true;
      try {
        await client.get(API.auth.currentUser);
        return client(config);
      } catch (currentUserError) {
        if (currentUserError.response?.status === 401) {
          removeItem('access_token');
          store.dispatch(actions.logoutSuccess(null));
        }
      }
    }

    return Promise.reject(error);
  },
);
export { client, authHeader };
